export default __webpack_public_path__ + "static/media/iso.cc352943.png";